import { schema } from "normalizr";

export const publisherFlag = new schema.Entity(
    "publisherFlags",
    {},
    { idAttribute: "name" }
);
export const publisherFlagList = new schema.Array(publisherFlag);
